import { createRouter } from '@tanstack/react-router'
import { NotFound } from './components/not-found'
import { Route as rootRoute } from './routes/__root'
import { Route as activityLogRoute } from './routes/activity-log'
import { Route as calendarRoute } from './routes/calendar'
import { Route as chatRoute } from './routes/chat'
import { Route as customersRoute } from './routes/customers'
import {
  DashboardAliasRoute as dashboardAliasRoute,
  Route as dashboardOverviewRoute,
} from './routes/dashboard-overview'
import { Route as dispositionRoute } from './routes/disposition'
import { Route as documentsRoute } from './routes/documents'
import { Route as documentDetailRoute } from './routes/documents-detail'
import { Route as finanzplanungRoute } from './routes/finanzplanung'
import { Route as guestRoute } from './routes/guest'
import { Route as guideRoute } from './routes/guide'
import { Route as importExportRoute } from './routes/import-export'
import { Route as invoicesRoute } from './routes/invoices'
import { Route as invoicesDetailRoute } from './routes/invoices-detail'
import { Route as invoicesFibuRoute } from './routes/invoices-fibu'
import { Route as invoicesNewRoute } from './routes/invoices-new'
import { Route as kanbanRoute } from './routes/kanban'
import { Route as logbookRoute } from './routes/logbook'
import { Route as loginRoute } from './routes/login'
import { Route as mailRoute } from './routes/mail'
import { Route as productsRoute } from './routes/products'
import { Route as projectsRoute } from './routes/projects'
import { Route as registerRoute } from './routes/register'
import { Route as servicesRoute } from './routes/services'
import { Route as settingsAiRoute } from './routes/settings-ai'
import { Route as settingsAppearanceRoute } from './routes/settings-appearance'
import { Route as settingsBlackoutsRoute } from './routes/settings-blackouts'
import { Route as settingsDashboardTemplatesRoute } from './routes/settings-dashboard-templates'
import { Route as settingsFetcherRoute } from './routes/settings-fetcher'
import { Route as settingsHolidaysRoute } from './routes/settings-holidays'
import { Route as settingsIntegrationsRoute } from './routes/settings-integrations'
import { Route as settingsInvitationsRoute } from './routes/settings-invitations'
import { Route as settingsInvoiceLayoutRoute } from './routes/settings-invoice-layout'
import { Route as settingsMailAccountsRoute } from './routes/settings-mail-accounts'
import { Route as settingsMailOAuthRoute } from './routes/settings-mail-oauth'
import { Route as settingsMailPushRoute } from './routes/settings-mail-push'
import { Route as settingsMeetingServerRoute } from './routes/settings-meeting-server'
import { Route as settingsOrgRoute } from './routes/settings-org'
import {
  SettingsIndexRedirectRoute as settingsIndexRedirectRoute,
  Route as settingsProfileRoute,
} from './routes/settings-profile'
import { Route as settingsRolesRoute } from './routes/settings-roles'
import { Route as settingsSurchargesRoute } from './routes/settings-surcharges'
import { Route as settingsTeamsRoute } from './routes/settings-teams'
import { Route as settingsUsersRoute } from './routes/settings-users'
import { Route as settingsVacationRulesRoute } from './routes/settings-vacation-rules'
import { Route as stammdatenRoute } from './routes/stammdaten'
import { Route as tagsRoute } from './routes/tags'
import { Route as tasksRoute } from './routes/tasks'
import { Route as teamPlanningRoute } from './routes/team-planning'
import { Route as ticketsRoute } from './routes/tickets'
import { Route as timeAccountsRoute } from './routes/time-accounts'
import { Route as usersDossierRoute } from './routes/users-dossier'
import { Route as welcomeRoute } from './routes/welcome'
import { Route as workflowsRoute } from './routes/workflows'

// Note: shifts.tsx (war in team-planning.tsx aufgegangen) und
// routeTree.gen.ts sind gelöscht (Audit-Branch, Vite-Plugin entfernt).
// Die früheren toten Route-Dateien absences.tsx / absences-team.tsx sind
// gelöscht; auswertung/meetings/requests leben als Panels unter
// components/ (Kalender-SidePanel) weiter.

const routeTree = rootRoute.addChildren([
  dashboardOverviewRoute,
  dashboardAliasRoute,
  calendarRoute,
  teamPlanningRoute,
  timeAccountsRoute,
  customersRoute,
  projectsRoute,
  logbookRoute,
  servicesRoute,
  productsRoute,
  chatRoute,
  mailRoute,
  workflowsRoute,
  tagsRoute,
  dispositionRoute,
  stammdatenRoute,
  documentsRoute,
  documentDetailRoute,
  invoicesRoute,
  invoicesNewRoute,
  invoicesFibuRoute,
  invoicesDetailRoute,
  finanzplanungRoute,
  tasksRoute,
  ticketsRoute,
  kanbanRoute,
  activityLogRoute,
  settingsAiRoute,
  settingsIndexRedirectRoute,
  settingsProfileRoute,
  settingsAppearanceRoute,
  settingsDashboardTemplatesRoute,
  settingsSurchargesRoute,
  settingsIntegrationsRoute,
  settingsInvitationsRoute,
  settingsInvoiceLayoutRoute,
  settingsMeetingServerRoute,
  settingsMailOAuthRoute,
  settingsMailAccountsRoute,
  settingsMailPushRoute,
  settingsTeamsRoute,
  settingsFetcherRoute,
  settingsHolidaysRoute,
  settingsBlackoutsRoute,
  settingsVacationRulesRoute,
  settingsRolesRoute,
  settingsOrgRoute,
  settingsUsersRoute,
  usersDossierRoute,
  loginRoute,
  registerRoute,
  guestRoute,
  welcomeRoute,
  guideRoute,
  importExportRoute,
])

export const router = createRouter({
  routeTree,
  basepath: import.meta.env.BASE_URL,
  defaultPreload: 'intent',
  // Gestaltete deutsche 404 statt des eingebauten „Not Found" (B7)
  defaultNotFoundComponent: NotFound,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
